import { NavLink } from "react-router-dom";
import useDocumentTitle from "hooks/useDocumentTitle";
import HeaderLogo from "../assets/images/logos/logo-header.png";
import { HelpSupport } from "../components/KnowledgeBaseSupport/HelpSupportList";
import KnowledgeBaseSupportAccordian from "../components/KnowledgeBaseSupport/KnowledgeBaseSupportAccordian";

function KnowledgeBaseSupport() {
  useDocumentTitle("Contact & Support");

  const handleNavigation = (id) => {
    const section = document.getElementById(id);
    if (section) {
      // Adjust scroll position by 4rem (64px) to account for sticky header
      const yOffset = -64; // 4rem = 64px
      const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
      // Add highlight effect
      section.classList.add("secondary-background-accent-color");
      setTimeout(() => {
        section.classList.remove("secondary-background-accent-color");
      }, 1000);
    }
  };

  return (
    <div className="w-full">
      <div className="w-full h-16 bg-black  z-50 sticky top-0 px-6 py-1 flex items-center justify-between">
        <div className=" ml-6 my-auto sm:block">
          <NavLink to="/login">
            <img className="w-[9.3rem] h-[2.0rem]" src={HeaderLogo} />
          </NavLink>
        </div>
        <div className="text-white h-10">
          <NavLink to="/login">
            <div
              role="button"
              className="border-gray-500 p-2 border bg-white text-black hover:bg-gray-200"
            >
              {"Sign In"}
            </div>
          </NavLink>
        </div>
      </div>
      <div class=""></div>
      <div className="p-[2%] overflow-y-scroll">
        <div className="">
          <div className=" w-full">
            <div className="">
              <div className="mb-5">
                <h1 className=" pl-2 ">Knowledge Base and Support</h1>
              </div>
              <div className="flex justify-between">
                <div class="secondary-background-accent-color px-4 py-3 text-left text-[#259f9b] break-words w-[500px] rounded ml-1">
                  <div class="mx-auto text-xl font-semibold">
                    <h4 className="text-[#259f9b]">Table of content</h4>
                  </div>
                  <ul class="mt-1 list-disc px-2 pl-6">
                    {/* <li>
                      <a
                        class="block px-2 py-1 rounded hover:bg-[#cfe4e4] text-[0.875rem]"
                        href="#contactUs"
                        onClick={() => handleNavigation("contactUs")}
                      >
                        Contact Us
                      </a>
                    </li> */}
                    {HelpSupport.map((x, y) => {
                      return (
                        <li>
                          <a
                            class="block px-2 py-1 rounded hover:bg-[#cfe4e4] text-[0.875rem]"
                            href={"#" + x.id}
                            onClick={() => handleNavigation(x.id)}
                          >
                            {x.title}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div class="bg-gray-100 px-4 py-3 text-left break-words w-[600px] h-[130px] rounded ml-1">
                  <div class="mx-auto text-xl font-semibold">
                    <h4 className="">Contact Us</h4>
                  </div>
                  <p className="ml-4 mt-2">
                    You can easily get in touch by emailing us at{" "}
                    <a
                      className="text-[#19BAB3] cursor-pointer hover:underline font-bold"
                      href="mailto:aaron@rulebookcompany.com"
                    >
                      aaron@rulebookcompany.com{" "}
                    </a>
                    . We are committed to responding as quickly as possible to
                    ensure you receive the help you need.
                  </p>
                </div>
              </div>

              <div className="mt-2">
                {/* <div
                  className="p-2"
                  id="contactUs"
                  style={{ scrollMarginTop: "5rem" }}
                >
                  <div className="flex space-x-2 items-center cursor-pointer pb-2 border-b-2 border-[#E2F4F4]">
                    <h4 className="">Contact Us -</h4>
                    <p className="">
                      You can easily get in touch by emailing us at{" "}
                      <a
                        className="text-[#19BAB3] cursor-pointer hover:underline font-bold"
                        href="mailto:aaron@rulebookcompany.com"
                      >
                        aaron@rulebookcompany.com{" "}
                      </a>
                      . We are committed to responding as quickly as possible to
                      ensure you receive the help you need.
                    </p>
                  </div>
                  <h4></h4>
                </div> */}
                {HelpSupport.map((x, y) => {
                  return <KnowledgeBaseSupportAccordian data={x} />;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KnowledgeBaseSupport;
